
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
Group
},
mounted(){
var hrefUrl = location.host;
hrefUrl = "http://softtone.jqweike.com/login?callback=" + encodeURIComponent(hrefUrl);
document.getElementById("a").href = hrefUrl;
if (localStorage.getItem("userName") != "" && localStorage.getItem("userName") != null && localStorage.getItem(
"userName") != undefined) {
document.getElementById("is_login").style.display = "block";
document.getElementById("no_login").style.display = "none";
} else {
document.getElementById("no_login").style.display = "block";
document.getElementById("is_login").style.display = "none";
}
},
methods: {
Share(type) {
var IDCode = this.GLOBAL.IDCode;
var ChapterID = this.GLOBAL.ChapterID;

var ResUrl = this.$api.PERSONALURL;
var WebUrl = this.$api.URL;

this.$api.GetCourse([IDCode])
.then((data) => {


var Name = data.data.Data[0].Name;

var urlData = IDCode+"/"+ChapterID;
var url= WebUrl+urlData;
var picurl = url+data.data.Data[0].Image;

if(type == "qzone"){
var sharestring=
'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?'
+'url='+url
+'&title='+Name
+'&pics='+Name
+'&summary='+Name
+'&desc='+Name;
window.open(sharestring,'newwindow','height=400,width=400,top=100,left=100');
}else if(type == "sinaminiblog"){
var sharestring='http://v.t.sina.com.cn/share/share.php?'
+'title='+Name
+'&url='+url
+'&content=utf-8&sourceUrl='+url
+'&pic='+picurl;
window.open(sharestring,'newwindow','height=400,width=400,top=100,left=100');
}else if(type == "weixin"){
document.getElementById("qrcode").innerHTML ="";
var qrcode = new QRCode(document.getElementById("qrcode"),{
text: url,
width:128,
height:128,
colorDark : "#000000",
colorLight : "#ffffff",
correctLevel : QRCode.CorrectLevel.H
});

}


})






}
},
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Share.vue